import React from 'react';
import styled from 'styled-components';

import { useTheme } from '@rover/kibble/themes';

const Spinner = styled.i`
  font-size: 14px;
  position: relative;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
  animation: spin 2s infinite linear;
`;

export type Props = {
  className?: string;
};

const LoadingSpinner = ({ className = '', ...other }: Props): JSX.Element => {
  const { colors } = useTheme();

  return (
    <Spinner
      style={{
        color: colors.text.tertiary.toString(),
      }}
      {...other}
      className={`rover-icon rover-icon-in-spinner ${className}`}
      data-testid="loading-spinner"
    />
  );
};
export default LoadingSpinner;
